import { useEffect } from 'react'
import { NavLink } from 'react-router-dom'
import { staticAssetsPath } from '../../../../../configs/constants'
import { useSasToken } from '../../../../../_hooks/useSasToken'
import { useThemeManager } from '../../../../../_hooks/useThemeManager'
import { IconLayoutSidebarLeftCollapse } from '@tabler/icons-react'
import { UncontrolledTooltip } from 'reactstrap'

const VerticalMenuHeader = (props) => {
  // ** Props
  const {
    menuCollapsed,
    setGroupOpen,
    menuHover,
    isFocusMode,
    setMenuVisibility,
    isSidebarVisible
  } = props
  const showIcon = (menuCollapsed && !menuHover) || isFocusMode
  const { appendToken, isLoading: isTokenLoading } = useSasToken()
  const { isDarkTheme } = useThemeManager()
  useEffect(() => {
    if (!menuHover && menuCollapsed) setGroupOpen([])
  }, [menuHover, menuCollapsed])

  const getLogo = () => {
    if (!isDarkTheme) {
      return showIcon || isFocusMode
        ? appendToken(`${staticAssetsPath}/images/logo/Centrali-Icon.svg`)
        : appendToken(`${staticAssetsPath}/images/logo/Centrali-Portal.svg`)
    } else {
      return showIcon || isFocusMode
        ? appendToken(`${staticAssetsPath}/images/logo/Centrali-Icon-dark.svg`)
        : appendToken(`${staticAssetsPath}/images/logo/Centrali-Portal-dark.svg`)
    }
  }

  const logoSrc = getLogo()

  // The collapsed/focus-mode state takes priority: always centre the icon and never
  // show the close button when the sidebar is in its narrow icon-only state.
  const isCollapsedOrFocus = menuCollapsed || isFocusMode

  return (
    <div
      className={`app-sidebar-header-frame flex items-center border-b border-[var(--sidebar-divider)] h-[50px] ${
        isCollapsedOrFocus
          ? 'justify-center'
          : isSidebarVisible
          ? 'ml-[1.5rem]'
          : 'justify-between ml-[1.5rem] mr-2'
      }`}>
      <NavLink to="/" className="navbar-brand">
        {!isTokenLoading && (
          <img
            src={logoSrc}
            alt="logo"
            height={32}
            width={isCollapsedOrFocus ? 32 : 120}
            className="transition-all duration-300 ease-in-out"
          />
        )}
      </NavLink>
      {!isSidebarVisible && !isCollapsedOrFocus && (
        <>
          <IconLayoutSidebarLeftCollapse
            size={24}
            className="cursor-pointer outline-none theme-text-subheading"
            id="close-sidebar"
            onClick={() => setMenuVisibility(false)}
          />
          <UncontrolledTooltip target="close-sidebar" placement="right">
            Close sidebar
          </UncontrolledTooltip>
        </>
      )}
    </div>
  )
}

export default VerticalMenuHeader
